import {
  START_FETCHING_USER_INFO,
  FETCHED_USER_INFO
} from '../actionTypes';

import { UserInfoType, UserInfoTypeObject } from '../../types/AppTypes';

interface InitialState {
  userInfo: UserInfoType;
  loading: boolean;
  error: any;
  message: any;
}

const initialState: InitialState = {
  userInfo: new UserInfoTypeObject(),
  loading: false,
  error: null,
  message: null
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action: any) {
  switch (action.type) {
    case START_FETCHING_USER_INFO: {
      return {
        ...state,
        userInfo: null,
        error: null,
        message: null,
        loading: true,
      };
    }
    case FETCHED_USER_INFO: {
      const { userInfo, error, message } = action.payload;
      return {
        ...state,
        userInfo,
        error,
        message,
        loading: false,
      };
    }
    default:
      return state;
  }
}
